//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
import { loadObjectFiles } from '../../components/File/FileUtils'
import { axiosPost } from '../../axios/axios.js'
import FilesGroup from '../../components/File/FilesGroup'
import FilesField from '../../components/File/FilesField.vue'
import ReportObjectAvatarEdit from './ReportObjectAvatarEdit.vue'

export default {
  components: {
    FilesField
  },
  props: {
    report: {
      type: Object,
      default: null
    },
    serviceObject: {
      type: Object,
      default: null
    },
    reportRoles: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      expanded: false,
      category: null
    }
  },
  mounted: function () {
    this.getFilesGroup(this.serviceObject).then(category => {
      Vue.set(this, 'category', category)
    })
  },
  methods: {
    getFilesGroup: async function (object) {
      if (object) {
        const documentType = 'serviceObjectPhoto'
        const filesGroupKey = documentType
        const documents = await loadObjectFiles({
          objectId: object.id,
          propertyKey: 'serviceObjectPhoto'
          // propertyKey: 'roadsDocuments'
        })

        let filesCount = 0
        documents.map(document => {
          document.name = object.name + '-' + (++filesCount) + '.' + document.contentType.split('/')[1] + ' (' + document.user + ', ' + (new Date(document.time).toLocaleString()) + ')'
          return true
        })
        return Promise.resolve(new FilesGroup({
          key: filesGroupKey,
          title: 'ФОТОГРАФИИ ОБЪЕКТА',
          readonly: true,
          propertyKey: 'serviceObjectPhoto',
          documentType: documentType,
          documents: documents
        }))
      }
    },
    onEditPhotos: function () {
      const dialog = this.$d.dialog(this).show({
        maximizedOnNarrow: true,
        noWrap: true,
        contentWidth: 1200,
        persistent: true,
        headerLabel: 'Редактировать фото объекта обслуживания',
        contentComponent: ReportObjectAvatarEdit,
        contentProps: {
          sourceCategory: this.category,
          report: this.report,
          serviceObject: this.serviceObject
        },
        componentHandlers: {
          save: () => {
            this.getFilesGroup(this.serviceObject).then(category => {
              Vue.set(this, 'category', category)
            })
            dialog.hide()
          },
          close: () => {
            dialog.hide()
          }
        }
      })
    }
  }
}

